import { EntityType } from "../../Common.types";
import { DocumentPreviewable } from "./DocumentPreview.types";

export function buildDocumentPreviewUrl(document: DocumentPreviewable, entityType: EntityType, entityId: string): string {
    const params = new URLSearchParams();
    if (document.fileName) params.set("fileName", document.fileName);
    if (document.dataId) params.set("dataId", document.dataId);
    if (document.documentVersionId) params.set("documentVersionId", document.documentVersionId);
    if (document.name) params.set("name", document.name);
    if (document.entityTitle) params.set("entityTitle", document.entityTitle);

    const query = params.toString();
    return `/privacy/document-preview/${entityType}/${encodeURIComponent(entityId)}/${encodeURIComponent(document.documentId)}${query ? `?${query}` : ""}`;
}
